export default {"src":"/_next/static/media/loader.2f1f2a46.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};